var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeaderPrimaryButton } from '../buttons/HeaderPrimaryButton';
import style from './AccountLoginButtonRow.module.scss';
import { useAperzaUserContext } from '../AperzaUserContext';
import { addUtmParam } from '../../utils/addUtmParam';
export function AccountLoginButtonRow() {
    var _a = useAperzaUserContext(), serviceType = _a.serviceType, signUpUrl = _a.signUpUrl, loginUrl = _a.loginUrl;
    return (_jsxs("div", __assign({ className: style.menuRow }, { children: [_jsx(HeaderPrimaryButton, __assign({ disableArrow: true, href: addUtmParam(loginUrl(), 'header', serviceType), buttonClassName: style.signButton }, { children: "\u30ED\u30B0\u30A4\u30F3" })), _jsx(HeaderPrimaryButton, __assign({ outlined: true, disableArrow: true, href: addUtmParam(signUpUrl(), 'header', serviceType), buttonClassName: style.signButton }, { children: "\u4F1A\u54E1\u767B\u9332\uFF08\u7121\u6599\uFF09" }))] })));
}
